import R1 from './VendorResource1';
import R2 from './VendorResource2';
import R3 from './VendorResource3';
import R4 from './VendorResource4';
import R5 from './VendorResource5';

export default [R1, R2, R3, R4, R5];
